/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React, { useEffect, useState } from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { AngleRightIcon } from "../../FontAwesome";
import { appRouterDefinitions } from "./../../../appRouterDefinitions";
import { useAppBreadcrumbsContext } from "./../AppBreadcrumbsContext";
import "./AppBreadcrumbs.scss";
import variablesScss from "../../Themes/variables.module.scss";

const breakpointsLg = parseInt(variablesScss.breakpointsLg, 10);

export default function AppBreadcrumbs() {
    const appBreadcrumbsContext = useAppBreadcrumbsContext();
    const [breadcrumbs, setBreadcrumbs] = useState<Array<JSX.Element>>([]);
    const [maxItems, setMaxItems] = useState<number>(100);

    const getMaxItems = (): number => {
        return window.outerWidth > breakpointsLg ? 100 : 2;
    };

    const handleMaxItems = () => {
        setMaxItems(getMaxItems());
    };

    const createBreadcrumbs = () => {
        const routeDefinition = appRouterDefinitions.find(
            (d) => d.path === appBreadcrumbsContext.path
        );
        let nextBreadcrumbs: Array<JSX.Element> = [];
        if (routeDefinition) {
            nextBreadcrumbs = routeDefinition.createBreadcrumbs(
                appBreadcrumbsContext.createBreadcrumbsProps
            );
            setBreadcrumbs(nextBreadcrumbs);
            setMaxItems(getMaxItems());
        }

        window.addEventListener("resize", handleMaxItems);
        return () => {
            window.removeEventListener("resize", handleMaxItems);
        };
    };

    useEffect(createBreadcrumbs, [appBreadcrumbsContext.url]);

    if (!breadcrumbs.length) {
        return null;
    }

    return (
        <div className="lan-appbreadcrumbs">
            <Breadcrumbs
                maxItems={maxItems}
                itemsBeforeCollapse={0}
                itemsAfterCollapse={2}
                separator={<AngleRightIcon fontSize="small" />}
            >
                {breadcrumbs.map((breadcrumb, idx) => (
                    <div key={idx}>{breadcrumb}</div>
                ))}
            </Breadcrumbs>
        </div>
    );
}
